import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';

import { APP_OPTIONS } from '../../../config/constants';
import useLayoutVariables from '../../../hooks/useLayoutVariables';

import './style.scss';

export interface LogoProps {
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ onClick }) => {
  const { LogoSVG } = useLayoutVariables('logo');
  const { t } = useTranslation();

  return (
    <CoreLink
      className="Logo"
      href="/"
      aria-label={t('menu.aria_label', { siteName: APP_OPTIONS.parameters.siteName })}
      onClick={onClick}
    >
      <LogoSVG />
    </CoreLink>
  );
};

export default Logo;
